import { render, staticRenderFns } from "./RedaTableView.vue?vue&type=template&id=f84080ce"
import script from "./RedaTableView.vue?vue&type=script&lang=js"
export * from "./RedaTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports